import { useContext } from 'react'
import { Context } from '../components/DailyVisitProvider'

export const useDailyVisit = () => {
  const context = useContext(Context)
  if (!context) {
    throw new Error('useDailyVisit must be used within a DailyVisitProvider')
  }
  return context
}
